module.exports = __webpack_public_path__ + "img/serveLogo5.66758078.png";